import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigateBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 45,
	height: 45,
	viewBox: "0 0 45 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.8031 11.2501L29.4469 13.8939L20.8594 22.5001L29.4469 31.1064L26.8031 33.7501L15.5531 22.5001L26.8031 11.2501Z",
		fill: "currentColor"
	})
});
export default SvgNavigateBack;
